import { Component, h } from 'preact';
import cx from 'classnames';

interface FileUploadFormControlProps {
  selectedFiles?: FileList;
  disabled?: boolean;
  accept?: string;

  onChange?: (event: Event) => void;
}

export class FileUploadFormControl extends Component<FileUploadFormControlProps> {
  componentDidMount() {
    // Preact recycles elements, which is problematic with file inputs.
    // Because file inputs work differently by not taking in values from component
    // state, it may start off in a completely fresh component pre-filled with
    // the value it was last set to.
    //
    // As we show a custom UI anyway, just reset the file input on every mount.
    // See also:
    // https://github.com/preactjs/preact/issues/187#issuecomment-225935629
    const inputElement = this.base.querySelector('input');
    inputElement.value = '';
  }

  render(props: FileUploadFormControlProps) {
    let label: string;
    const selectedFiles = this.props.selectedFiles;

    if (selectedFiles) {
      label = `${selectedFiles.length} ${selectedFiles.length === 1 ? 'file' : 'files'} selected`;
    } else {
      label = 'Upload file';
    }

    return (
      <div className="hi-inqloiupload__upload-body-field">
        <div className="hi-inqloiupload__upload-box-group">
          <div className={ cx('hi-inqloiupload__upload-box', {
            'with-files': !!(selectedFiles),
            'disabled': props.disabled
          }) }>
            { label }
          </div>
          <button className="btn btn-outline-dark hi-inqloiupload__upload-button"
            disabled={ props.disabled }>
            Select
          </button>
        </div>
        <input className="hi-inqloiupload__upload-input" type="file"
          placeholder="Upload file"
          multiple={ true }
          accept={ props.accept || "image/*" }
          onInput={ props.onChange }
          disabled={ props.disabled } />
      </div>
    )
  }
}
